(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('SavedFormValueDetailController', SavedFormValueDetailController);

    SavedFormValueDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SavedFormValue', 'AppraiserUser'];

    function SavedFormValueDetailController($scope, $rootScope, $stateParams, entity, SavedFormValue, AppraiserUser) {
        var vm = this;

        vm.savedFormValue = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:savedFormValueUpdate', function(event, result) {
            vm.savedFormValue = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
